module.exports = function(app) {
    app.directive('eprReportCodesValidator', ['eprReportCodesErrors', function(eprReportCodesErrors) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
            	codeInfo: '=eprReportCodesValidator'
            },

            link: function (scope, elm, attrs, ctrl) {
                ctrl.$parsers.push(function(value) {
					if (eprReportCodesErrors[scope.codeInfo.groupNumber]) {
						delete eprReportCodesErrors[scope.codeInfo.groupNumber][scope.codeInfo.code.abbreviatedType];
					}
                	return value;
                });
                ctrl.$validators.eprReportCodesValidator = function() {
                	if (eprReportCodesErrors && eprReportCodesErrors[scope.codeInfo.groupNumber] && eprReportCodesErrors[scope.codeInfo.groupNumber][scope.codeInfo.code.abbreviatedType]) {
                		return false;
                	}
                	return true;
                };
            }
        };
    }]);
    app.value('eprReportCodesErrors', {});
	app.directive('eprReportCodes', function() {
		return {
			template: require('directives/employee/eprReportCodes.html'),
			restrict: 'A',
			replace: false,

			scope: {
				eprReportCodes: '=eprReportCodes',
				editMode: '=?',
				employee: '=?eprReportCodesEmployee',
				showGroups: '=showGroups'
			},

			controller: ['$scope', 'services', 'employee', 'eprReportCodesErrors', '$filter', function ($scope, services, employee, eprReportCodesErrors, $filter) {
				$scope.employee = $scope.employee || employee; // TODO: remove this, adjust all later 'employee' to '$scope.employee'

				employee.metadata.reportCodeGroups = {};
				var subscriber = employee.data.subscriber;

				$scope.eprReportCodesErrors = eprReportCodesErrors;

				$scope.shouldShow = function(codeGroup) {
					var shouldShow = true;
					if ($scope.showGroups) {
						shouldShow = shouldShow && $scope.showGroups.indexOf(codeGroup.groupNumber) != -1;
					}
					if (!$scope.editMode) {
						shouldShow = shouldShow && !!codeGroup.reportCodes.find(function(v) { return v.value; });
					}
					return shouldShow;
				};

				$scope.hasCodes = function() {
					return $scope.reportCodeGroups.some(function(codeGroup) {
						return $scope.shouldShow(codeGroup);
					});
				};

				$scope.reportCodeGroups = [];
				$scope.$watchCollection('eprReportCodes', function() {
					while ($scope.reportCodeGroups.length) { $scope.reportCodeGroups.pop(); }
					$scope.eprReportCodes.forEach(function(groupNumber) {
						services.eprsvc.groupInformation().getReportCodes(groupNumber).then(
							function(response) {
								if (response && response.data && response.data.payload && response.data.payload.length > 0) {
									if ($scope.eprReportCodes.indexOf(groupNumber) != -1) { // Make sure groupNumber is still in the array, if eprReportCodes changes quickly, service calls can queue up and previous calls will run after the latest splice, causing duplicate entries
										if (!$scope.reportCodeGroups.find(function(v) { return groupNumber == v.groupNumber; })) {
											$scope.reportCodeGroups.push({
												groupNumber: groupNumber,
												reportCodes: angular.copy(response.data.payload)
											});
										}
									}
								}
							},
							function() {
							}
						);
					});
				});

				$scope.codeChange = function(code, codeGroup) {
					if ($scope.employee === employee) {
						// If employee factory was passed in, we need to keep the data in metadata, cuz eprPlanCoverage would erase our work...
						if (code && code.value) {
							employee.metadata.reportCodeGroups[codeGroup.groupNumber] = employee.metadata.reportCodeGroups[codeGroup.groupNumber] || {};
							employee.metadata.reportCodeGroups[codeGroup.groupNumber][code.abbreviatedType] = {
								abbreviatedType: code.abbreviatedType,
								type: code.type,
								value: code.value && code.value.toUpperCase && code.value.toUpperCase(),
								required: code.required
							};
						}
						else if (
							employee.metadata &&
							employee.metadata.reportCodeGroups &&
							employee.metadata.reportCodeGroups[codeGroup.groupNumber] &&
							employee.metadata.reportCodeGroups[codeGroup.groupNumber][code.abbreviatedType]
						) {
							delete employee.metadata.reportCodeGroups[codeGroup.groupNumber][code.abbreviatedType];
						}
					}
					else {
						// If a custom $scope.employee was passed in, we'll put the updated group codes there instead
						if (code.value) {
							$scope.employee.data.subscriber.memberCoverages.forEach(function(coverage) {
								if (coverage.groupNumber == codeGroup.groupNumber) {
									coverage.reportCodes = coverage.reportCodes || [];
									var foundCode = coverage.reportCodes.find(function(v) { return v.abbreviatedType == code.abbreviatedType; });
									if (foundCode) {
										foundCode.value = code.value && code.value.toUpperCase && code.value.toUpperCase();
										// Need to delete the following values, incase code was blanked out then re-entered
										delete foundCode.effectiveDate;
										delete foundCode.cancelDate;
										delete foundCode.cancel;
									}
									else {
										var newIndex = coverage.reportCodes.push(code) - 1;
										coverage.reportCodes[newIndex].value = code.value && code.value.toUpperCase && code.value.toUpperCase();
										delete coverage.reportCodes[newIndex].codes; // We don't need this in the potential payload
										delete coverage.reportCodes[newIndex].effectiveDate;
										delete coverage.reportCodes[newIndex].cancelDate;
										delete coverage.reportCodes[newIndex].cancel;
									}
								}
							});
						}
						else {
							$scope.employee.data.subscriber.memberCoverages.forEach(function(coverage) {
								if (coverage.groupNumber == codeGroup.groupNumber) {
									if (originals && originals[coverage.groupNumber] && originals[coverage.groupNumber][code.abbreviatedType]) {
										// trying to delete a code that was previously saved, send cancel: true and effectiveDate
										var foundCode = coverage.reportCodes.find(function(v) { return v.abbreviatedType == code.abbreviatedType; });
										if (foundCode) {
											foundCode.value = originals[coverage.groupNumber][code.abbreviatedType].value;
											foundCode.effectiveDate = originals[coverage.groupNumber][code.abbreviatedType].effectiveDate;
											foundCode.cancel = true;
										}
									}
									else {
										// erasing a code that has not yet been saved, we simply need to splice it out
										coverage.reportCodes = coverage.reportCodes || [];
										var found = coverage.reportCodes.findIndex(function(v) { return v.abbreviatedType == code.abbreviatedType; });
										if (found != -1) {
											coverage.reportCodes.splice(found, 1);
										}
										if (coverage.reportCodes.length == 0) {
											delete coverage.reportCodes; // We don't need the empty array hanging around for the payload
										}
									}
								}
							});
						}
					}
				};



				var originals = {};
				$scope.$watchCollection('reportCodeGroups', function() {
					// putting this in a scope.watch cuz of the ng-if being switched to ng-show
					for (k in originals) {
						delete k;
					}
					Object.keys($scope.reportCodeGroups).forEach(function(product) {
						$scope.reportCodeGroups[product].reportCodes.forEach(function(code) {
							if (subscriber.memberCoverages && subscriber.memberCoverages.length > 0) {
								var i = subscriber.memberCoverages.length;
								while (i--) {
									if (subscriber.memberCoverages[i].groupNumber == $scope.reportCodeGroups[product].groupNumber) {
										if (subscriber.memberCoverages[i].reportCodes) {
											subscriber.memberCoverages[i].reportCodes.forEach(function(savedCode) {
												if (savedCode.abbreviatedType == code.abbreviatedType) {
													code.value = savedCode.value;
													$scope.codeChange(code, $scope.reportCodeGroups[product]);
													originals[$scope.reportCodeGroups[product].groupNumber] = originals[$scope.reportCodeGroups[product].groupNumber] || {};
													originals[$scope.reportCodeGroups[product].groupNumber][savedCode.abbreviatedType] = originals[$scope.reportCodeGroups[product].groupNumber][savedCode.abbreviatedType] || {
														value: savedCode.value,
														effectiveDate: savedCode.effectiveDate
													};
												}
											});
										}
									}
								}
							}
						});
					});
				});

				var forms = [];
				$scope.initForm = function(index) {
					forms.push(this['reportCodes_'+index]);
				};

				$scope.getForm = function(suffix) {
					return this["reportCodes_" + suffix];
				};

				$scope.getFormField = function(fieldName, suffix) {
					return (this.getForm(suffix) || {})[fieldName];
				};

				$scope.$on('validateReportCodes', function(event) {
					console.debug('heard validateReportCodes');

					var payloadGroups = [];
					for (var product in $scope.reportCodeGroups) {
						var codeGroup = $scope.reportCodeGroups[product];
						var currentGroup = {
							"groupNumber": codeGroup.groupNumber,
							"coverageStartDate": $filter('date')($scope.employee.data.globalCoverageEffectiveDate, 'MM/dd/yyyy'),
							"reportCodes": []
						};
						payloadGroups.push(currentGroup);
						codeGroup.reportCodes.forEach(function(code) {
							if (code.value) {
								currentGroup.reportCodes.push({
									abbreviatedType: code.abbreviatedType,
									type: code.type,
									value: code.value && code.value.toUpperCase && code.value.toUpperCase(),
									required: code.required
								});
							}
						});
					}
					Object.keys(eprReportCodesErrors).forEach(function(v) { delete eprReportCodesErrors[v]; });
					services.eprsvc.reportCodesValidate().validate(payloadGroups).then(function(response) {
						if (response && response.data && response.data.payload) {
							if (response.data.payload.length === 0) {
								$scope.$emit('reportCodesValidated', true);
							}
							else if (response.data.payload.length > 0) {
								$scope.$emit('reportCodesValidated', false);
								response.data.payload.forEach(function(invalidCode) {
									var parts = invalidCode.match(/Group ([0-9]+): .*\((.*)\)/);
									if (parts) {
										var groupNumber = parts[1];
										var abbreviatedType = parts[2];
										eprReportCodesErrors[groupNumber] = eprReportCodesErrors[groupNumber] || {};
										eprReportCodesErrors[groupNumber][abbreviatedType] = invalidCode;
									}
								});
								// super hacky code below
								forms.forEach(function(form) {
									Object.keys(form).forEach(function(key) {
										if (key.indexOf('_') > 0) {
											form[key].$validate();
										}
									});
								});
							}
						}
					}, function(error) {
						$scope.$emit('reportCodesValidated', false);
					});
				});
			}]
		};
	});
};
